import { Text, Icon } from '@scale/scaleui-radix';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';

const FdeScriptTransformerHeader = () => {
  return (
    <div className="mb-3">
      <div className="flex items-start gap-4">
        <div className="flex flex-col items-center">
          <img
            src="https://scale-static-assets.s3.us-west-2.amazonaws.com/fde_app_store_small.png"
            alt="FDE App Store"
            className="w-16 h-16 rounded-xl object-cover brightness-150"
          />
          <div className="flex gap-0.25 mt-0.5">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="relative inline-block w-3 h-3">
                <Icon
                  icon={faStarRegular}
                  className="text-yellow-500 absolute -top-0 left-0 w-2.5 h-2.5 z-10"
                  label="Star outline"
                  data-testid="star-icon"
                />
                <Icon
                  icon={faStarSolid}
                  className="text-yellow-400 absolute top-0 left-0 w-2.5 h-2.5 z-0"
                  label="Star"
                  data-testid="star-icon"
                />
              </span>
            ))}
          </div>
        </div>
        <div className="flex flex-col">
          <Text as="div" size="4" className="font-bold">
            FDE Tools
          </Text>
          <Text as="div" size="1" className="text-gray-500 mb-2">
            Developer Tools • Data Transformation • Custom Actions
          </Text>
          <Text as="p" className="text-gray-600">
            Select a predefined script to transform your data. The script will be executed on the
            backend and can be used to perform complex transformations that aren't possible with
            other cards.
          </Text>
        </div>
      </div>
    </div>
  );
};

export default FdeScriptTransformerHeader;
